import React from 'react';
import { createRoot } from 'react-dom/client';

import { updateHTML } from './helpers/html';

import { App } from './app';

updateHTML();

const container = document.getElementById('app');
const root = createRoot(container!);
root.render(<App />);
